import * as React from "react";
const SvgChat = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 9.23C3 5.678 6.409 3 10.339 3s7.338 2.677 7.338 6.23-3.409 6.231-7.338 6.231c-.903 0-1.768-.14-2.567-.394l-2.557 1.918a.692.692 0 0 1-1.107-.554v-3.907C3.412 11.577 3 10.45 3 9.231m7.339-4.845c-3.413 0-5.954 2.283-5.954 4.846 0 .958.345 1.86.956 2.628.098.122.151.274.151.431v2.756l1.743-1.307a.69.69 0 0 1 .656-.095 7 7 0 0 0 2.448.433c3.412 0 5.953-2.283 5.953-4.846s-2.542-4.846-5.954-4.846",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.029 9.776a.69.69 0 0 1 .963.175A5.52 5.52 0 0 1 21 13.11c0 1.22-.413 2.346-1.108 3.293v3.907a.692.692 0 0 1-1.076.576l-2.811-1.874a8.5 8.5 0 0 1-2.343.329c-2.012 0-3.852-.688-5.19-1.822a.692.692 0 1 1 .895-1.056c1.075.91 2.593 1.493 4.294 1.493.792 0 1.545-.13 2.237-.36a.7.7 0 0 1 .601.082l2.009 1.338v-2.847c0-.156.053-.309.15-.431.612-.768.957-1.67.957-2.628 0-.855-.272-1.663-.762-2.37a.69.69 0 0 1 .176-.963",
    clipRule: "evenodd"
  }
));
export default SvgChat;
